import React from 'react'
import BaseLayout from 'layouts/base-layout/BaseLayout'
import style from "./index.module.scss"
import QR from "assets/img/png/icon_erweima@2x.png"
import signin from "assets/img/png/icon_user@2x.png"
import { Tooltip } from 'antd'
import { useHistory } from 'react-router-dom'
import { RouterPaths} from 'utils/constant'
import { isMobile } from 'utils/utils'
interface Props extends React.Props<any> {
  type?: 'signin' | 'signup' | 'other' | 'qr',
}

function SignLayout ({ children, type = 'other' }: Props) {
  const history = useHistory()

  return (
    <BaseLayout>
      <div className={style['g-sign']}>
        <div className={style.box} >
          {
            isMobile() ? null : (
              <Tooltip visible title={ type === 'qr' ? '账号登录/注册' : 'App 扫码登录' } placement="leftTop">
                <div className={style.qr} onClick={() =>
                  type === 'qr' ? history.push(`${RouterPaths["signin-phone"]}${window.location.search}`)  :
                    history.push(`${RouterPaths["signin-qr"]}${window.location.search}`)
                }>
                  <img src={ type === 'qr' ? signin : QR } alt="" />
                </div>
              </Tooltip>
            )
          }
          { children }
        </div>
      </div>
    </BaseLayout>
  )
}

export default SignLayout
